import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RentOrderInfoComponent = _resolveComponent("RentOrderInfoComponent")!
  const _component_VehicleInfoComponent = _resolveComponent("VehicleInfoComponent")!
  const _component_OrderChoosePaymentComponent = _resolveComponent("OrderChoosePaymentComponent")!
  const _component_OrderFormComponent = _resolveComponent("OrderFormComponent")!
  const _component_VehicleOrderTemplateComponent = _resolveComponent("VehicleOrderTemplateComponent")!
  const _component_TransportationOrderInfoComponent = _resolveComponent("TransportationOrderInfoComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.serviceType === _ctx.services.SERVICE_RENT)
      ? (_openBlock(), _createBlock(_component_VehicleOrderTemplateComponent, { key: 0 }, {
          "order-info": _withCtx(() => [
            _createVNode(_component_RentOrderInfoComponent, {
              "order-data": !_ctx.withDriver ? _ctx.store.state.orderFalseDriver : _ctx.store.state.orderTrueDriver,
              "with-driver": _ctx.withDriver
            }, null, 8, ["order-data", "with-driver"])
          ]),
          "vehicle-info": _withCtx(() => [
            _createVNode(_component_VehicleInfoComponent, {
              vehicle: _ctx.store.state.vehicle.selectedVehicle
            }, null, 8, ["vehicle"]),
            _cache[0] || (_cache[0] = _createElementVNode("div", {
              class: "col-sm-12 col-md-12 col-lg-11 hr-line",
              style: {"margin-top":"3.5rem"}
            }, null, -1))
          ]),
          "payment-type": _withCtx(() => [
            _createVNode(_component_OrderChoosePaymentComponent, { "payment-methods-prop": _ctx.paymentMethods }, null, 8, ["payment-methods-prop"])
          ]),
          "order-form": _withCtx(() => [
            _createVNode(_component_OrderFormComponent)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.serviceType === _ctx.services.SERVICE_TRANSPORTATION)
      ? (_openBlock(), _createBlock(_component_VehicleOrderTemplateComponent, { key: 1 }, {
          "order-info": _withCtx(() => [
            _createVNode(_component_TransportationOrderInfoComponent, {
              "order-data": _ctx.roundTrip ? _ctx.trueRoundTrip : _ctx.falseRoundTrip,
              "is-round-trip": _ctx.roundTrip,
              "is-loading": _ctx.isLoading
            }, null, 8, ["order-data", "is-round-trip", "is-loading"])
          ]),
          "payment-type": _withCtx(() => [
            _createVNode(_component_OrderChoosePaymentComponent, { "payment-methods-prop": _ctx.paymentMethods }, null, 8, ["payment-methods-prop"])
          ]),
          "order-form": _withCtx(() => [
            _createVNode(_component_OrderFormComponent, { "is-loading": _ctx.isLoading }, null, 8, ["is-loading"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}